import { toTimestamp } from '@core/_utils/date.utils';



export function isValid(rawToken) {
    if (!rawToken) { return  false; };
    // try {
        const body = getTokenBody(rawToken);

        if (isExpired(body)) {
            // throw new Error('Token expired');
            return false;
        }
        return true;

    // }catch (e) {
    //     throw e;
    // }
}


export function getTokenBody(rawToken) {
    rawToken = rawToken.split('.')[1];
    rawToken = rawToken.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(rawToken));
}


function isExpired(parsedToken) {
    const exp = parsedToken.exp * 1000;
    let date;
    date = new Date;
    date = toTimestamp(date);

    if (exp <= date) {
        return true;
    }

    return false;
}
